import styled from 'styled-components';

import React from 'react';
import { Icon } from '../../../../components/common/icon/Icon';
import { Button } from '../../../../components/common/buttons/Button';
import { useNavigate } from 'react-router-dom';
import { marketPricePageInfo } from '../../../../constants/pageInfo/pageInfo.constant';

export const EmptyResult = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <ContentsContainer>
        <Icon name={'BookBox'} width={60} height={60} />
        <Description>{'찾으시는 정보 없네요.\n브랜드나 모델명으로 다시 검색해보세요!'}</Description>
      </ContentsContainer>
      <ButtonWrapper>
        <Button
          borderType={'square'}
          size={'md'}
          text={{ size: 'md', content: '다시 검색하기' }}
          color={'filledGreyLight'}
          icon={{ position: 'right', size: 'Medium', fileName: 'AngleRight', fill: '#505363' }}
          onClick={() => navigate(marketPricePageInfo.searchPage.path, { replace: true })}
        />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 48px);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;

  padding: 16px 16px 32px 16px;
`;

const ContentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const Description = styled.pre`
  color: var(--Light-Scheme-Monochrome-grey70, #a7a9b6);
  text-align: center;

  /* Body/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;

const ButtonWrapper = styled.div`
  width: 167px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin-top: 8px;
  padding-bottom: 40px;
`;
